import React, { useMemo } from "react";
import "./ContactPage.css";

function ContactPage() {
  // adresaci formularza – łatwo zmienisz w jednym miejscu
  const recipients = useMemo(
    () => ["artur.janicki@cst.pl", "szymon.pycha@cst.pl"],
    []
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = new FormData(e.currentTarget);
    const name = form.get("name") || "";
    const email = form.get("email") || "";
    const subject = form.get("subject") || "Kontakt z CST";
    const message = form.get("message") || "";

    const to = recipients.join(",");
    const body =
      `Imię i nazwisko: ${name}\n` +
      `Email: ${email}\n\n` +
      `${message}`;

    const mailto = `mailto:${to}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    window.location.href = mailto;
  };

  return (
    <section className="contact">
      <header className="contact__hero">
        <h1>Kontakt</h1>
        <p>Jesteśmy tu, żeby pomóc. Wybierz preferowany sposób kontaktu.</p>
      </header>

      <div className="contact-grid">
        {/* --- Karta: Administracja (Artur) --- */}
        <article className="contact-card">
          <div className="contact-card__header">
            <div className="contact-card__icon">👨‍💼</div>
            <div>
              <h3>Właściciel Firmy</h3>
              <p className="muted">Artur Janicki</p>
            </div>
          </div>
          <ul className="contact-list">
            <li>
              <span>✉️</span>
              <a href="mailto:artur.janicki@cst.pl">artur.janicki@cst.pl</a>
            </li>
            <li>
              <span>📞</span>
              <a href="tel:+48512181778">+48&nbsp;512&nbsp;181&nbsp;778</a>
            </li>
          </ul>
        </article>

        {/* --- Karta: Administracja (Szymon) --- */}
        <article className="contact-card">
          <div className="contact-card__header">
            <div className="contact-card__icon">🧑‍💻</div>
            <div>
              <h3>Administracja systemu</h3>
              <p className="muted">Szymon Pycha</p>
            </div>
          </div>
          <ul className="contact-list">
            <li>
              <span>✉️</span>
              <a href="mailto:szymon.pycha@cst.pl">szymon.pycha@cst.pl</a>
            </li>
            <li>
              <span>📞</span>
              <a href="tel:+48798465172">+48&nbsp;798&nbsp;465&nbsp;172</a>
            </li>
          </ul>
        </article>

        {/* --- Karta: Serwis --- */}
        <article className="contact-card contact-card--accent">
          <div className="contact-card__header">
            <div className="contact-card__icon">🛠️</div>
            <div>
              <h3>Serwis CST</h3>
              <p className="muted">Zgłoszenia i wsparcie</p>
            </div>
          </div>
          <ul className="contact-list">
            <li>
              <span>📞</span>
              <a href="tel:+48785859299">+48&nbsp;785&nbsp;859&nbsp;299</a>
            </li>
          </ul>
          <div className="hours">
            <strong>Godziny pracy:</strong>
            <span>pn–pt, 7:00–15:00</span>
          </div>
        </article>
      </div>

      {/* Formularz mailto – lekki i bez backendu */}
      <div className="contact-form-card">
        <h3>Napisz do nas</h3>
        <p className="muted">
          Wypełnij krótki formularz – otworzymy Twojego email'a z gotową treścią.
        </p>
        <form onSubmit={handleSubmit} className="contact-form">
          <div className="form-row">
            <label>
              Imię i nazwisko
              <input name="name" type="text" placeholder="Jan Kowalski" required />
            </label>
            <label>
              E-mail
              <input name="email" type="email" placeholder="jan.kowalski@firma.pl" required />
            </label>
          </div>
          <label>
            Temat
            <input name="subject" type="text" placeholder="Krótki temat wiadomości" />
          </label>
          <label>
            Wiadomość
            <textarea
              name="message"
              rows={5}
              placeholder="Opisz krótko sprawę – im więcej szczegółów, tym szybciej pomożemy."
              required
            />
          </label>

          <div className="form-actions">
            <button type="submit" className="btn-primary">Wyślij wiadomość</button>
            <a className="btn-link" href={`mailto:${recipients.join(",")}`}>Otwórz pustą wiadomość</a>
          </div>
        </form>
      </div>
    </section>
  );
}

export default ContactPage;
